/* Beeren maatgids-widget — initialiseert elke .mgp-popup.
 *
 * Waarom extern i.p.v. inline <script> in de snippet:
 * de popup zit in Symmetry's [data-dynamic-variant-content], dat bij elke
 * variant-/maatwissel via innerHTML opnieuw wordt ingespoten. Inline <script>
 * in innerHTML draait NIET -> lege popup bij een andere maat dan de eerste.
 * Dit bestand laadt 1x en her-initialiseert via een MutationObserver elke
 * nieuwe/vervangen .mgp die in de DOM verschijnt.
 */
(function () {
  'use strict';
  if (window.__beerenMaatgidsLoaded) return;
  window.__beerenMaatgidsLoaded = true;

  /* Officiele BEEREN-lichaamsmaten (cm-ranges) — Kiwi */
  var HEREN = [
    { maat: 'XS/3', lengte: [158, 168], borst: [83, 88], taille: [76, 81] },
    { maat: 'S/4', lengte: [162, 172], borst: [88, 93], taille: [80, 85] },
    { maat: 'M/5', lengte: [166, 176], borst: [94, 99], taille: [86, 91] },
    { maat: 'L/6', lengte: [170, 180], borst: [100, 105], taille: [92, 97] },
    { maat: 'XL/7', lengte: [174, 184], borst: [106, 111], taille: [98, 103] },
    { maat: 'XXL/8', lengte: [178, 188], borst: [112, 117], taille: [104, 109] },
    { maat: '3XL/9', lengte: [180, 190], borst: [118, 123], taille: [110, 115] },
    { maat: '4XL', lengte: [184, 194], borst: [124, 131], taille: [116, 123] },
    { maat: '5XL', lengte: [186, 196], borst: [132, 143], taille: [124, 135] },
    { maat: '6XL', lengte: [188, 198], borst: [144, 152], taille: [136, 147] }
  ];
  var CHARTS = {
    'dames-onder': {
      primary: 'taille',
      inputs: [
        { key: 'taille', label: 'Taillemaat (cm)', ph: 'bijv. 74', hint: 'Smalste deel van je middel' },
        { key: 'heup', label: 'Heupomvang (cm)', ph: 'bijv. 100', hint: 'Breedste deel van je heupen', optional: true }
      ],
      cols: [{ key: 'confectie', label: 'Confectie' }, { key: 'taille', label: 'Taille' }, { key: 'heup', label: 'Heupen' }],
      sizes: [
        { maat: 'S', confectie: '36', taille: [64, 67], heup: [90, 93] },
        { maat: 'M', confectie: '38/40', taille: [68, 77], heup: [94, 103] },
        { maat: 'L', confectie: '42/44', taille: [78, 87], heup: [104, 113] },
        { maat: 'XL', confectie: '46/48', taille: [88, 97], heup: [114, 123] },
        { maat: 'XXL', confectie: '50/52', taille: [98, 107], heup: [124, 133] },
        { maat: '3XL', confectie: '54', taille: [108, 112], heup: [134, 138] },
        { maat: '4XL', confectie: '56/58', taille: [113, 117], heup: [139, 143] }
      ]
    },
    'dames-boven': {
      primary: 'borst',
      inputs: [{ key: 'borst', label: 'Borstomvang (cm)', ph: 'bijv. 92', hint: 'Breedste deel van je borst' }],
      cols: [{ key: 'confectie', label: 'Confectie' }, { key: 'borst', label: 'Borstomvang' }],
      tnote: 'Borstmaten zijn een indicatie op basis van de standaard EU-confectiemaat. Twijfel je? Kies de grootste maat.',
      sizes: [
        { maat: 'S', confectie: '36', borst: [76, 83] },
        { maat: 'M', confectie: '38/40', borst: [84, 91] },
        { maat: 'L', confectie: '42/44', borst: [92, 99] },
        { maat: 'XL', confectie: '46/48', borst: [100, 107] },
        { maat: 'XXL', confectie: '50/52', borst: [108, 115] },
        { maat: '3XL', confectie: '54', borst: [116, 119] },
        { maat: '4XL', confectie: '56/58', borst: [120, 127] }
      ]
    },
    'heren-onder': {
      primary: 'taille',
      inputs: [
        { key: 'taille', label: 'Taillemaat (cm)', ph: 'bijv. 94', hint: 'Smalste deel van je middel' },
        { key: 'lengte', label: 'Lengte (cm)', ph: 'bijv. 178', hint: 'Je lichaamslengte', optional: true }
      ],
      cols: [{ key: 'taille', label: 'Taille' }, { key: 'lengte', label: 'Lengte' }, { key: 'borst', label: 'Borst' }],
      sizes: HEREN
    },
    'heren-boven': {
      primary: 'borst',
      inputs: [
        { key: 'borst', label: 'Borstomvang (cm)', ph: 'bijv. 100', hint: 'Breedste deel van je borst' },
        { key: 'taille', label: 'Taillemaat (cm)', ph: 'bijv. 94', hint: 'Smalste deel van je middel', optional: true },
        { key: 'lengte', label: 'Lengte (cm)', ph: 'bijv. 178', hint: 'Je lichaamslengte', optional: true }
      ],
      cols: [{ key: 'borst', label: 'Borst' }, { key: 'taille', label: 'Taille' }, { key: 'lengte', label: 'Lengte' }],
      sizes: HEREN
    },
    'kinderen': {
      primary: 'lengte',
      inputs: [{ key: 'lengte', label: 'Lengte kind (cm)', ph: 'bijv. 116', hint: 'Meet het kind rechtop, zonder schoenen' }],
      cols: [{ key: 'leeftijd', label: 'Leeftijd' }, { key: 'lengte', label: 'Lengte' }],
      sizes: [
        { maat: '104', leeftijd: '3-4 jaar', lengte: [99, 104] },
        { maat: '110', leeftijd: '4-5 jaar', lengte: [105, 110] },
        { maat: '116', leeftijd: '5-6 jaar', lengte: [111, 116] },
        { maat: '128', leeftijd: '7-8 jaar', lengte: [123, 128] },
        { maat: '140', leeftijd: '9-10 jaar', lengte: [135, 140] },
        { maat: '152', leeftijd: '11-12 jaar', lengte: [146, 152] },
        { maat: '164', leeftijd: '12-13 jaar', lengte: [158, 164] },
        { maat: '176', leeftijd: '14-15 jaar', lengte: [170, 176] },
        { maat: '188', leeftijd: '16-17 jaar', lengte: [182, 188] }
      ]
    }
  };
  var CONFECTIE = { '36': 'S', '38': 'M', '40': 'M', '42': 'L', '44': 'L', '46': 'XL', '48': 'XL', '50': 'XXL', '52': 'XXL', '54': '3XL', '56': '4XL', '58': '4XL' };
  var CONF_OPTS = ['36', '38', '40', '42', '44', '46', '48', '50', '52', '54', '56', '58'];
  var HOWTO = {
    taille: '<strong>Taille:</strong> meetlint om het smalste deel van je middel.',
    heup: '<strong>Heupen:</strong> meetlint om het breedste deel van je heupen.',
    borst: '<strong>Borst:</strong> meetlint horizontaal op het breedste deel van je borst.',
    lengte: '<strong>Lengte:</strong> rechtop, zonder schoenen.'
  };

  function initOne(ROOT) {
    if (!ROOT || ROOT.dataset.mgpInit) return;
    ROOT.dataset.mgpInit = '1';

    var CTX = ROOT.dataset.ctx;
    var chart = CHARTS[CTX] || CHARTS['heren-boven'];
    var isDames = CTX.indexOf('dames') === 0;
    var pickerEl = ROOT.querySelector('.mgp__picker');
    var tablesEl = ROOT.querySelector('.mgp__tables');
    if (!pickerEl || !tablesEl) return;

    var S = { conf: '', inputs: {}, rec: null };

    function rangeFor(sz, key) { var r = sz[key]; return (r && typeof r !== 'string') ? r : null; }
    function idxForMeasure(key, v) {
      var s = chart.sizes;
      for (var i = 0; i < s.length; i++) { var r = rangeFor(s[i], key); if (r && v <= r[1]) return { idx: i, under: (v < r[0] && i === 0) }; }
      return { idx: s.length - 1, over: true };
    }
    function findSize() {
      var cand = [];
      chart.inputs.forEach(function (inp) { var v = S.inputs[inp.key]; if (v > 0) cand.push({ label: inp.label, res: idxForMeasure(inp.key, v) }); });
      if (!cand.length) return null;
      var idxs = cand.map(function (c) { return c.res.idx; });
      var maxI = Math.max.apply(null, idxs), minI = Math.min.apply(null, idxs);
      var over = cand.some(function (c) { return c.res.over; });
      var under = cand.every(function (c) { return c.res.under; });
      var sz = chart.sizes[maxI], note = '';
      if (over) note = 'Je valt boven de grootste maat (' + chart.sizes[chart.sizes.length - 1].maat + '). Neem gerust contact op voor advies.';
      else if (under) note = 'Je valt onder de kleinste maat (' + chart.sizes[0].maat + '). Deze maat is waarschijnlijk nog ruim.';
      else if (maxI > minI) {
        var driver = cand.filter(function (c) { return c.res.idx === maxI; }).map(function (c) { return c.label.replace(/\s*\(cm\)/, '').toLowerCase(); }).join(' / ');
        note = 'Je maten vallen in verschillende maten. We adviseren de grootste (' + sz.maat + ') op basis van je ' + driver + '.';
      }
      return { maat: sz.maat, over: over, note: note };
    }
    function cell(sz, key) { var v = sz[key]; if (v == null) return '—'; if (typeof v === 'string') return v; return v[0] + '–' + v[1] + ' cm'; }

    function renderPicker() {
      var html = '';
      if (isDames) {
        html += '<div class="mgp__field"><label class="mgp__lbl">Ken je je confectiemaat? <span class="mgp__opt">sneller</span></label>'
          + '<select class="mgp__inp mgp__conf"><option value="">— kies —</option>'
          + CONF_OPTS.map(function (c) { return '<option value="' + c + '"' + (S.conf === c ? ' selected' : '') + '>' + c + '</option>'; }).join('')
          + '</select></div><div class="mgp__or">of meet jezelf</div>';
      }
      chart.inputs.forEach(function (inp) {
        var val = S.inputs[inp.key] || '';
        html += '<div class="mgp__field"><label class="mgp__lbl">' + inp.label
          + (inp.optional ? ' <span class="mgp__opt">optioneel</span>' : '') + '</label>'
          + '<input class="mgp__inp" type="number" inputmode="numeric" data-key="' + inp.key + '" placeholder="' + inp.ph + '" min="0" max="250" value="' + val + '">'
          + '<p class="mgp__hint">' + inp.hint + '</p></div>';
      });
      html += '<button type="button" class="mgp__btn mgp__calc">Bereken mijn maat &rarr;</button>';
      if (S.rec) {
        html += '<div class="mgp__res"><span class="mgp__res-lbl">Jouw maat</span><span class="mgp__res-size' + (S.rec.over ? ' over' : '') + '">' + S.rec.maat + '</span></div>';
        if (S.rec.note) html += '<p class="mgp__note">' + S.rec.note + '</p>';
      }
      html += '<div class="mgp__howto"><h4>Hoe meten?</h4><ul>';
      chart.inputs.forEach(function (inp) { if (HOWTO[inp.key]) html += '<li>' + HOWTO[inp.key] + '</li>'; });
      html += '<li>Lintje strak maar niet inknijpend.</li></ul></div>';
      return html;
    }
    function renderTable() {
      var rec = S.rec ? S.rec.maat : null, html = '';
      html += '<table class="mgp__tbl"><thead><tr><th>Maat</th>';
      chart.cols.forEach(function (c) { html += '<th' + (c.key === chart.primary ? ' class="mgp-key"' : '') + '>' + c.label + '</th>'; });
      html += '</tr></thead><tbody>';
      chart.sizes.forEach(function (sz) {
        html += '<tr' + (sz.maat === rec ? ' class="rec"' : '') + '><td>' + sz.maat + '</td>';
        chart.cols.forEach(function (c) { html += '<td' + (c.key === chart.primary ? ' class="mgp-key"' : '') + '>' + cell(sz, c.key) + '</td>'; });
        html += '</tr>';
      });
      html += '</tbody></table><p class="mgp__tbl-note">'
        + (chart.tnote || 'Officiële BEEREN-lichaamsmaten. Beeren-ondergoed heeft rekstof; twijfel je tussen twee maten, kies de grootste.')
        + '</p>';
      return html;
    }
    function update() {
      pickerEl.innerHTML = renderPicker();
      tablesEl.innerHTML = renderTable();
      bind();
    }
    function calc() {
      if (isDames) {
        var cf = ROOT.querySelector('.mgp__conf');
        S.conf = cf ? cf.value : '';
        if (S.conf && CONFECTIE[S.conf]) { S.inputs = {}; S.rec = { maat: CONFECTIE[S.conf], over: false, note: 'Op basis van confectiemaat ' + S.conf + '.' }; update(); return; }
      }
      S.inputs = {};
      chart.inputs.forEach(function (inp) { var el = ROOT.querySelector('.mgp__inp[data-key="' + inp.key + '"]'); var v = el ? parseFloat(el.value) : NaN; if (v > 0) S.inputs[inp.key] = v; });
      S.rec = findSize(); update();
    }
    function bind() {
      var btn = ROOT.querySelector('.mgp__calc');
      if (btn) btn.addEventListener('click', calc);
      chart.inputs.forEach(function (inp) { var el = ROOT.querySelector('.mgp__inp[data-key="' + inp.key + '"]'); if (el) el.addEventListener('keydown', function (e) { if (e.key === 'Enter') calc(); }); });
      var cf = ROOT.querySelector('.mgp__conf'); if (cf) cf.addEventListener('change', calc);
    }
    update();
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll ? scope.querySelectorAll('.mgp') : [];
    for (var i = 0; i < nodes.length; i++) initOne(nodes[i]);
    if (root && root.classList && root.classList.contains('mgp')) initOne(root);
  }

  function boot() {
    initAll(document);
    // Her-init bij dynamic-variant re-render: nieuwe .mgp-nodes via innerHTML.
    if (window.MutationObserver) {
      var obs = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.classList && n.classList.contains('mgp')) initOne(n);
            else if (n.querySelectorAll) initAll(n);
          }
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
